module.exports = (__webpack_require__(9237))("./src/icons.js");